import React, { useEffect, useRef } from 'react';

import { ImportTestCasesStatusContext } from '@qality/common-components/src/lib/ImportTestCasesStatusProvider';
import { ImportTestCasesForm } from '@qality/common-components/src/molecules/ImportTestCasesForm';
import { ImportFailure } from '@qality/common-components/src/molecules/ImportTestCasesForm/ImportFailure';
import { ImportSummary } from '@qality/common-components/src/molecules/ImportTestCasesForm/ImportSummary';
import { StorageOfUniqueServices } from '@qality/common-service';

import { ImportWizardPageStyled } from './ImportWizardPage.styled';

const ImportWizardPage = (): JSX.Element => {
  const { isImportFinished, importErrorObject } = React.useContext(
    ImportTestCasesStatusContext
  );
  const ref = useRef(null);
  useEffect(() => {
    const ResizeService = StorageOfUniqueServices.get('ResizeService');
    ResizeService.init(ref);
    ResizeService.resize(80); //we need to add 80px so there is space for dropdown menu
  }, [ref]);
  return (
    <ImportWizardPageStyled innerRef={ref}>
      {isImportFinished ? (
        <ImportFinished importErrorObject={importErrorObject} />
      ) : (
        <ImportTestCasesForm />
      )}
    </ImportWizardPageStyled>
  );
};
function ImportFinished({ importErrorObject }: any) {
  return importErrorObject ? <ImportFailure /> : <ImportSummary />;
}

export default ImportWizardPage;
